import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGetAgentsResponse } from "../../api/agents/index.types";

export interface IAgentsState {
  data: {
    agents: IGetAgentsResponse["data"]["agents"];
    agentsWithCustomPreset: Record<number, string[]>;
    count: number;
  };
  loading: boolean;
}

const initialState: IAgentsState = {
  data: {
    agents: [],
    agentsWithCustomPreset: {},
    count: 0,
  },
  loading: false,
};

const index = createSlice({
  name: "agents",
  initialState,
  reducers: {
    fetchAgentsRequest: (state) => {
      state.loading = true;
    },
    fetchAgentsSuccess: (
      state,
      action: PayloadAction<{
        agents: IGetAgentsResponse["data"]["agents"];
        agentsWithCustomPreset: IGetAgentsResponse["data"]["agentsWithCustomPreset"];
        count: number;
      }>
    ) => {
      const agentsWithCustomerPreset: Record<number, string[]> = {};
      action.payload.agentsWithCustomPreset.flat().forEach(({ admin_accounts_id, option_name }) => {
        admin_accounts_id.forEach((admin_id) => {
          if (agentsWithCustomerPreset[admin_id]) {
            agentsWithCustomerPreset[admin_id].push(option_name);
          } else {
            agentsWithCustomerPreset[admin_id] = [option_name];
          }
        });
      });
      state.data.agentsWithCustomPreset = agentsWithCustomerPreset;
      state.data.agents = action.payload.agents;
      state.data.count = action.payload.count;
      state.loading = false;
    },
    fetchAgentsFailed: (state) => {
      state.loading = false;
    },
  },
});

export const agentsActions = index.actions;
export default index.reducer;
